import BaseSequence from './BaseSequence'


class OpeningSequence extends BaseSequence {
  constructor(converter, pos) {
    super(converter, pos, true)
  }
}

export default OpeningSequence